/**
 * File: apps/qbench-cp/reactapp/src/Order/SelectTests/EditTests/AssignmentTable/Checkbox.js
 *
 * Purpose: Renders a custom checkbox control used for row and select-all selection in the
 *     test-assignment table.
 *
 * Scope: AssignmentTable within the EditTests test-assignment flow.
 *
 * Tags: customer-portal, orders, tests
 *
 * Overview: Renders a clickable square with a checkmark icon that toggles appearance based on
 *     `isChecked` and `disabled` props, using styled-components for the checked/unchecked and
 *     disabled visual states. Spreads any additional props (e.g. `onClick`, `className`) onto the
 *     outer wrapper.
 *
 * Exports: Checkbox — default export, the checkbox control. Wrapper — named export, the outer
 *     styled-components container reused by sibling styles.
 */

import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

export const Wrapper = styled.div`
  cursor: pointer;
  & > div {
    cursor: pointer;
  }
`;

const Check = styled.div`
  width: 1.125rem;
  height: 1.125rem;
  padding: 2px 1px 1px 2px;
  border-radius: 0.25rem;
  color: ${(props) => (props.$checked ? 'white' : 'transparent')};
  background: ${(props) => (props.$checked ? '#144896' : 'transparent')};
  border: 2px solid ${(props) => (props.$checked ? '#144896' : '#d8d8d8')};
  cursor: ${(props) => (props.$disabled ? 'not-allowed' : 'default')};
`;

export default function Checkbox({ disabled = false, isChecked, ...props }) {
  return (
    <Wrapper {...props}>
      <Check
        className="d-flex align-items-center justify-content-center lh-1"
        $checked={isChecked}
        $disabled={disabled}
      >
        <FontAwesomeIcon icon={faCheck} fill="currentColor" size="sm" />
      </Check>
    </Wrapper>
  );
}
